export default __webpack_public_path__ + "static/media/green-info.e427e6c0.svg";